import { css } from '@compiled/react';
import { MOBILE } from '../../utils/constants';
import PostDetail from 'components/forums/post-detail/PostDetail';
import { forumsV2IsActive } from '../../services/statsig/featureGates';
import { useRouter } from 'react-resource-router';
import Spinner from '@atlaskit/spinner';
import { Suspense } from 'react';

// TODO: Add PageWithAnalytics wrapper when analytics are ready
const ForumsV2PostPage = () => {
  const [, { push }] = useRouter();

  if (!forumsV2IsActive()) {
    push('/page-not-found');
  }

  return (
    <div css={containerStyle}>
      <Suspense
        fallback={
          <div css={loadingStyles}>
            <Spinner size="large" />
          </div>
        }
      >
        <PostDetail />
      </Suspense>
    </div>
  );
};

const containerStyle = css`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  width: 100%;
  ${MOBILE.MEDIA_QUERY} {
    padding: 16px;
  }
`;

const loadingStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
});

export default ForumsV2PostPage;
